function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './ComponentsWrapper.css';
import React, { useRef, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
function handleScrollToRef(scrollElemRef, extraHeightCalculator) {
  if (!scrollElemRef.current) {
    return;
  }
  const scrollElem = scrollElemRef.current;
  if (!scrollElem) {
    return;
  }
  let mainHeight = 0;
  const mainNav = document.querySelector('.main-nav-static');
  if (mainNav) {
    mainHeight = mainNav.clientHeight;
  }
  const extraHeight = extraHeightCalculator && mainNav ? extraHeightCalculator(mainNav) : 0;
  const combinedHeight = mainHeight + extraHeight + 10;
  const rect = scrollElem.getBoundingClientRect();
  const scrollPosition = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
  window.scrollTo(0, scrollPosition - combinedHeight);
}
const ComponentsWrapper = _ref => {
  let {
    removePaddingMobile = false,
    removePaddingHeader = false,
    removePaddingBottom = false,
    removePaddingTop = false,
    removePadding = false,
    removePaddingInside = false,
    minHeight = false,
    fullWidth = false,
    children,
    className,
    style = {},
    anchorUrlParameter,
    componentTabIndex = 0
  } = _ref;
  const siteName = '';
  const componentRef = useRef(null);
  const [offsetTop, setOffsetTop] = useState(0);
  const history = useHistory();
  const hash = history.location.hash && decodeURI(history.location.hash.split('#')[1]) || null;
  const extraHeightCalculator = mainNavElem => {
    const afterHeight = parseInt(window.getComputedStyle(mainNavElem, '::after').height || '');
    return afterHeight;
  };
  const handleScroll = () => {
    // @ts-ignore
    if (componentRef && componentRef.current && componentRef.current.offsetTop != offsetTop)
      // @ts-ignore
      setOffsetTop(componentRef.current.offsetTop || 0);
  };
  useEffect(() => {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      handleScrollToRef(componentRef, extraHeightCalculator);
    }
  }, [offsetTop]);
  useEffect(() => {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);
  const conditionalWrapperProps = useMemo(() => {
    if (componentTabIndex === 'disabled') {
      return {};
    }
    return {
      tabIndex: componentTabIndex
    };
  }, [componentTabIndex]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `container ${siteName} ${className} ${minHeight ? commonStyles : ''}`,
    "data-anhor": anchorUrlParameter,
    ref: componentRef,
    style: style
  }, conditionalWrapperProps), /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'module-group': !fullWidth,
      'remove-padding-mobile': removePaddingMobile,
      'remove-padding-header': removePaddingHeader,
      'remove-padding': removePadding,
      'remove-padding-bottom': removePaddingBottom,
      'remove-padding-top': removePaddingTop,
      'remove-padding-inside': removePaddingInside
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, typeof children === 'function' ? children() : /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, children)))));
};
const commonStyles = "c1nbdvx8";
export default ComponentsWrapper;